module.exports = "//docs.gtimg.com/slide/img/_/node_modules/@tencent/docs-design-resources/pc/svg/animation_pane_outline_light_24-f7a77a.svg";